<div class="wrapper" #wrapper>
  <div class="avatar" [ngClass]="size()" (click)="avatarClicked.emit(wrapper)">{{ name() }}</div>
</div>
